import script from "./CompSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./CompSearch.vue?vue&type=script&setup=true&lang=js"

import "./CompSearch.vue?vue&type=style&index=0&id=d5b22c2e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5b22c2e"]])

export default __exports__